import { render, staticRenderFns } from "./ConversationAnswerEnd.vue?vue&type=template&id=3f1486c9&scoped=true&"
import script from "./ConversationAnswerEnd.vue?vue&type=script&lang=js&"
export * from "./ConversationAnswerEnd.vue?vue&type=script&lang=js&"
import style0 from "./ConversationAnswerEnd.vue?vue&type=style&index=0&id=3f1486c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1486c9",
  null
  
)

export default component.exports